export default function getResource (label) {
    const resources = { default: 'Par défaut' };

    return resources[label];
}
